import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import BidderItem from '../../../components/auction/bidder-item/BidderItem';
import RectangularButton from '../../../components/buttons/RectangularButton';
import { BidderDto } from '../utils/bidderTypes';
import { usePlaceBidPopup } from '../hooks/usePlaceBidPopup';
import { useBiddersList } from '../hooks/useBiddersList';
import { AuctionDto } from '../../../services/Auction/auctionService.dto';
import { UserDetailsDto } from '../../../services/User/userService.dto';
import LoadingIndicator from '../../../components/loading/LoadingIndicator';
import { SectionContainer, SectionSingleColumn } from './layoutComponents';

const ListContainer = styled.div`
  overflow-y: auto;
  width: 100%;
  flex-shrink: 1;
`;

const PlaceBidButton = styled(RectangularButton)`
  width: 100%;
  min-height: 40px;
`;

interface Props {
  resolveAuthToken: () => Promise<string | undefined>;
  refetchAuction: () => void;
  auction?: AuctionDto;
  technicalUser?: UserDetailsDto;
}

const BidsList = ({ auction, resolveAuthToken, refetchAuction, technicalUser }: Props) => {
  const { t } = useTranslation('onsite');

  const { canPlaceBid, showPlaceBidPopup } = usePlaceBidPopup(auction);
  const { bidders } = useBiddersList(auction, technicalUser);

  const handlePlaceBidClick = async () => {
    const authToken = await resolveAuthToken();
    if (authToken && auction) {
      showPlaceBidPopup(auction, authToken, refetchAuction);
    }
  };

  if (!auction) {
    return (
      <SectionContainer>
        <LoadingIndicator />
      </SectionContainer>
    );
  }

  return (
    <SectionContainer>
      <SectionSingleColumn>
        <PlaceBidButton label={t('bids.place-bid-button')} disabled={!canPlaceBid} onClick={handlePlaceBidClick} />

        <ListContainer>
          {bidders.map((bidder: BidderDto) => (
            <BidderItem key={bidder.bid.id} bidder={bidder} />
          ))}
        </ListContainer>
      </SectionSingleColumn>
    </SectionContainer>
  );
};

export default BidsList;
